const HeartSVG = ({ className }: { className?: string }) => {
    return (
        <svg
            data-testid="heart"
            className={className}
            width="20"
            height="18"
            viewBox="0 0 20 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10 17.994C9.678 17.991 9.292 17.836 8.842 17.529C4.652 14.375 0 11.46 0 5.995C0 2.627 2.42 0 5.5 0C7.24 0 8.91 0.883 10 2.267C11.09 0.883 12.76 0 14.5 0C17.58 0 20 2.627 20 5.995C20 11.518 15.138 14.49 11.146 17.529C10.704 17.843 10.322 17.999 10 17.994Z"
            />
        </svg>
    );
};

// eslint-disable-next-line import/no-default-export
export default HeartSVG;
